import { Component, OnInit,Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AuthenticatorComponent } from 'src/app/tools/authenticator/authenticator.component';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


@Injectable({
  providedIn: 'root'
})

export class HomeComponent implements OnInit {

  firestore = new FirebaseTSFirestore();
  auth = new FirebaseTSAuth();

  constructor(private loginSheet: MatBottomSheet, private router: Router,private authService: AuthService,) { }

  

  ngOnInit(): void {
    if(this.authService.isAuthenticatedAnonymous() ){
      this.router.navigate(['/profileSetup']);  // Redirige vers HomeComponent si l'utilisateur n'est pas authentifié
    } else
    if(this.authService.isAuthenticated() ){
      this.router.navigate(['postfeed']);  // Redirige vers HomeComponent si l'utilisateur n'est pas authentifié
    }
     // Faire patienter l'utilisateur pendant 2 secondes avant de naviguer vers HomeComponent2
     setTimeout(() => {

      const currentUser = this.auth.getAuth().currentUser;

        // Vérifiez d'abord si currentUser n'est pas null
        if (currentUser && currentUser.uid) {
          //alert("iyeuh");
        } else {
          this.router.navigate(['/home2']); // Rediriger vers HomeComponent2 après 2 secondes
        }
     
     
    }, 2500); // 2000 millisecondes = 2 secondes
  }
  

  onGetStartedClick(){
    this.loginSheet.open(AuthenticatorComponent);
  }
}
